import { gql } from '@apollo/client'

export const GET_INVENTORY_CITIES = gql`
  query InventoryCities(
    $fromDate: ISO8601DateTime
    $toDate: ISO8601DateTime
    $topTen: Boolean
    $cities: [String!]
    $agglomerations: [String!]
    $mediaFormat: MediumFormatEnum
    $first: Int
    $last: Int
  ) {
    inventoryCities(
      fromDate: $fromDate
      toDate: $toDate
      cities: $cities
      agglomerations: $agglomerations
      mediaFormat: $mediaFormat
      topTen: $topTen
      first: $first
      last: $last
    ) {
      nodes {
        asId
        freeSlots
        totalSlots
        allocatedSlots
        occupiedPercentage
        cityName
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`
